import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const BlueBtn = styled.button`
  padding: 0 20px;
  margin: 15px;
  background-color: var(--lp-colors-medium-blue-800);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-800);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 40px;
  &:disabled {
    opacity: 0.5;
  }
  &:first-of-type {
    margin-left: 0;
  }
`;

export const SearchBox = styled.input`
  vertical-align: middle;
  padding: 10px 17px 4px;
  outline: none;
  background-color: #fff;
  border: 1px solid #dce3eb;
  border-radius: 3px;
  width: 200px;
  color: #000;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.3);
  box-sizing: border-box;

  &:focus {
    border: 1px #505bcc solid;
    box-shadow: none;
  }
`;

export const FilterBtn = styled.button`
  margin-left: 10px;
  padding: 0 20px;
  margin: 15px;
  background-color: var(--lp-colors-medium-blue-800);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-800);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 30px;
  &:disabled {
    opacity: 0.5;
  }
`;

export const FilterPopup = styled.div`
  position: absolute;
  top: 75px;
  left: 628px;
`;

export const ItemList = styled.ul`
  list-style: none;
  margin: 0;
  line-height: 22px;
  display: flex;
  flex-flow: column nowrap;
  padding: 0;

  .item {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  > li {
    border-top: 1px solid #e6eaee;
    padding: 8px 0;

    &:first-child,
    &:nth-child(2) {
      border: 0;
    }
  }

  .item-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    min-width: 100%;
    position: relative;
  }

  .item-col {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 4px 0px;
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 3;
    -ms-flex-positive: 3;
    flex-grow: 3;
    -ms-flex-negative: 3;
    flex-shrink: 3;
    margin-right: 0;
    min-width: 0;
    padding-right: 10px;

    .card-status-icon {
      svg {
        vertical-align: middle;
        margin-right: 10px;
      }
      &.status-blocked svg {
        color: red;
      }
      &.status-unblocked svg {
        color: green;
      }
    }

    &.item-col-header span {
      font-size: 15px;
      color: #6c7488;
    }
    &.fixed {
      -webkit-box-flex: 0;
      -ms-flex-positive: 0;
      flex-grow: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      position: absolute;
      right: 0;
    }
    &.item-col-actions-dropdown {
      padding-right: 0;
      width: 20px;
      height: 38px;
      cursor: pointer;
    }
    .item-actions-dropdown {
      width: 100%;
    }
    .item-label {
      font-size: 12px;
      border: 1px solid #aaa;
      padding: 1px 8px 0px;
      border-radius: 4px;
      &.info {
        // border-color: green;
        color: green;
      }
      &.warning {
        // border-color: orange;
        color: orange;
      }
      &.critical {
        // border-color: red;
        color: red;
      }
    }
  }

  .item-actions-block {
    display: none;

    &.active {
      display: block;
    }
  }

  .item-actions-block {
    max-width: 0;
    opacity: 0;
    line-height: 30px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 24px;
    background-color: #fff;
    padding: 15px 25px;
    border: 1px solid #e7e7e7;
    box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
    border-radius: 3px;
    transition: all 0.15s ease-in-out;
    z-index: 1;

    &.active {
      display: block;
      max-width: 450px;
      opacity: 1;
    }

    .item-actions-list {
      list-style: none;
      white-space: nowrap;
      padding: 0;
      margin: 0;

      li {
        padding: 3px 0;
        margin: 0;
        &:first-child {
          border: 0;
        }
      }

      a {
        color: #6c7488;
        display: block;
        font-size: 15px;
        line-height: 24px;

        svg {
          vertical-align: text-bottom;
          font-size: larger;
          margin-right: 6px;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  .link-btn {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const SpinnerWrapper = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EditFormRow = styled.div`
  display: flex;
  input {
    max-height: 40px;
  }
`;

export const FormControl = styled.select`
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
`;

export const ActivateBtn = styled.button`
  width: 80px;
  height: 24px;
  background-color: var(--lp-colors-medium-blue-600);
  border: 1px solid var(--lp-colors-medium-blue-600);
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  padding: 4px 10px 4px 10px;
  margin-left: 20px;
  font-size: 13px;
  &:focus {
    outline: none;
  }
`;

export const TextInput = styled(Input)`
  padding-left: 10px;
`;

export const FormField = styled.div`
  position: relative;
`;

export const FormCurrencyField = styled.div`
  position: relative;
  &:before {
    content: '$';
    left: 1px;
    top: 1px;
    border: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    position: absolute;
    line-height: 38px;
    background: #f8f9fb;
    width: 35px;
    text-align: center;
  }
`;

export const Button = styled.button`
  position: relative;
`;

export const PaginationRow = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
`;

interface VInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
}
export const VInput = styled(Input)<VInputProps>`
  width: 500px;
  border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #dce3eb')};
  &:focus {
    border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #505bcc')};
  }
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
  color: #6c7488;
`;

export const Flex = styled.div`
  display: flex;
`;

type BtnProps = {
  width?: string;
  hasMarginLeft?: boolean;
};

export const Btn = styled.button<BtnProps>`
  background-color: var(--lp-colors-medium-blue-600);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-600);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: ${({ width }) => width ?? '150px'};
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  padding: 12px 0 9px;
  cursor: pointer;
  outline: none;
  margin-left: ${({ hasMarginLeft }) => (hasMarginLeft ? '15px' : '0')};
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const BtnSpinner = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 6px;
  padding-top: 1px;
`;

export const InvalidText = styled.div`
  font-size: 14px;
  color: red;
  position: absolute;
  right: 159px;
`;
